import { FC, lazy, Suspense } from 'react';
import { PdpSharedDetail, PdpSharedDetailProps } from './PdpSharedDetail';

type Props = PdpSharedDetailProps & {
    isClient: boolean;
};

export const PdpSharedDetailLabReport: FC<Props> = ({ isClient, ...props }) => {
    const LabReportTip = lazy(
        () =>
            import(
                /* webpackChunkName: "PdpSharedDetailLabReportTip" */ './PdpSharedDetailLabReportTipLazy'
            )
    );

    return (
        <>
            <PdpSharedDetail {...props} />
            {isClient && (
                <Suspense fallback="">
                    <LabReportTip />
                </Suspense>
            )}
        </>
    );
};
